// ink-component
import React from 'react';
import styled from 'styled-components';

import FormattedNumber from '../FormattedNumber/FormattedNumber';

export interface FormattedMultipleProps {
  /** Original value to be formatted */
  value?: string | number;
  /** Number of decimal places in the final formatted result */
  precision?: number;
  /** Optional prefix */
  prefix?: string;
  /** Optional suffix */
  suffix?: string;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

const StyledSpan = styled.span`
  font-feature-settings: 'calt' off;
`;

/**
 * @purpose Formats numbers into multiples
 * @group Formatted
 * @categories formatter
 */
function FormattedMultiple(props: FormattedMultipleProps) {
  const { precision } = props;
  function defineFormat() {
    return `0${precision ? `.${'0'.repeat(precision)}` : ''}`;
  }

  return (
    <StyledSpan>
      <FormattedNumber {...props} format={defineFormat()} />
    </StyledSpan>
  );
}

FormattedMultiple.defaultProps = {
  value: undefined,
  precision: 0,
  prefix: '',
  suffix: '\u00D7',
  'data-testid': undefined,
};

FormattedMultiple.displayName = 'FormattedMultiple';

export default FormattedMultiple;
